import { createSinglePathSegmentTransition } from '../../utils/createSinglePathSegmentTransition';
import { SegmentGeneratorFn } from '../XYChart/SegmentGeneratorFn';

export const lineSegmentTransitionGenerator: SegmentGeneratorFn = (pointTransitionsSegment) => {
  let initialPathSegment = '';
  let transitionPathSegment = '';
  let startNewSegment = true;

  for (let i = 0; i < pointTransitionsSegment.length - 1; i += 1) {
    // create segments from pair of points at a time
    const firstPoint = pointTransitionsSegment[i];
    const secondPoint = pointTransitionsSegment[i + 1];

    if (
      (firstPoint.from.value === undefined && firstPoint.to.value === undefined) ||
      (secondPoint.from.value === undefined && secondPoint.to.value === undefined)
    ) {
      startNewSegment = true;
    } else {
      const [pathSegmentFrom, pathSegmentTo] = createSinglePathSegmentTransition(
        firstPoint,
        secondPoint,
        startNewSegment,
      );
      initialPathSegment += pathSegmentFrom;
      transitionPathSegment += pathSegmentTo;
      startNewSegment = false;
    }
  }

  return [initialPathSegment, transitionPathSegment];
};
